/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { ChartLegendComponent } from './chart-legend/chart-legend.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfigService } from '../../../service/config.service';
import { StockChart } from 'angular-highcharts';
import { ColorPipe } from '../../../pipe/color.pipe';
import { ColorScorePipe } from '../../../pipe/color-score.pipe';
import { ColorScore2Pipe } from '../../../pipe/color-score2.pipe';
import { FeatureFlagsService } from 'src/app/shared/services/customer-api/feature-flags.service';
import { QueryApiService } from 'src/app/shared/services/customer-api/query-api.service';
import {
  getScoreNameInfo,
  getScoresInfo,
  getScoreType,
} from 'src/app/shared/utils/score-type-details';
import { PortfolioApiService } from 'src/app/shared/services/customer-api/portfolio-api.service';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import * as moment from 'moment';
import * as d3 from 'd3';
import { forkJoin, merge, of, Subject } from 'rxjs';
import { catchError, filter, take, takeUntil } from 'rxjs/operators';
import { NewsChartScoreService } from './news-chart-score.service';
import { ScoreUtilsService } from 'src/app/shared/utils/score-utils.service';
import * as FileSaver from 'file-saver';
import domtoimage from 'dom-to-image';
import * as _ from 'lodash';
import * as XLSX from 'xlsx';
import html2canvas from 'html2canvas';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';
import {
  DEFAULT_SCORE_WINDOW_DAYS,
  ScoreFocusedEventsService,
} from '../news-chartmap/score-focused-events.service';
import { DateUtils } from 'src/app/shared/utils/date.utils';
import {
  NewsChartEventRow,
  NewsChartEventsService,
  NewsChartScoreFocusedEventsResult,
} from './news-chart-events.service';
import { SentimentService } from 'src/app/shared/services/data-api/sentiment.service';
import { PriceDataService } from 'src/app/shared/services/quant-api/price-data.service';
import { NewsChartDataService } from './news-chart-data.service';
import { INTERNAL_COCKPIT_SETTINGS } from 'src/app/shared/utils/cockpit-constants';

const EMPTY_EVENTS_ANALYTICS =
  (): NewsChartScoreFocusedEventsResult['eventsAnalytics'] => ({
    byFactuality: { fact: [], probable: [], possible: [], na: [] },
    byTemporality: { past: [], present: [], future: [], na: [] },
  });

/**
 * In this component we use the {@link https://www.highcharts.com/stock/demo | Highstock Chart} the yAxis are two: one for the volume and one for the sentiment but the xAxis is generated by another stock chart to allow the navigation in time
 */

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-chart',
  templateUrl: './news-chart.component.html',
  styleUrls: ['./news-chart.component.scss'],
})
export class NewsChartComponent implements OnInit, OnDestroy {
  h2c: any = html2canvas;
  titolo: any;
  private destroy$ = new Subject<void>();
  /** Cancels the previous refresh's in-flight fetch (stale-entity guard). */
  private refreshCancel$ = new Subject<void>();
  /** Reflows each chart on container resize — the SVG renders short until a resize otherwise. */
  private chartResizeObservers: ResizeObserver[] = [];
  loading: boolean;
  options: object;
  options2: object;
  home: any = [];
  serie_multi: any;
  stockChart: StockChart;
  stockChartRef: any;
  izoom: StockChart;
  izoomRef: any;
  theme: string;
  params: any;
  myparams: any;
  chartinit: boolean;
  previousValue: any;
  previousValue2: any;
  timeframe = '7';
  period1: number;
  period2: number;
  ioption: any;
  project: any;
  setup: any;
  volume_ts: any;
  quotient_ts: any;
  quotient_ts2: any;
  score_ts: any;
  score_ts_E: any;
  score_ts_S: any;
  score_ts_G: any;
  scoreE_last: any;
  scoreS_last: any;
  scoreG_last: any;
  prices: any;
  fully = {
    max: null,
    min: null,
  };
  instart: boolean;
  iizoom: string;
  currency: string;
  fromSearchQuery: boolean;
  fromPortfolio: boolean;
  scoreOverride: boolean;
  scoreOnChart: any;
  esgSetup: boolean;

  /** Events inside the selected timeframe — drives the chart's own series. */
  events: any;
  /** Same fetch, full score window — shared with the mosaic's sparklines. */
  scoreWindowEvents: NewsChartEventRow[] = [];
  eventsAnalytics: any;
  ievents: any;
  nodata: boolean;
  showAverage: boolean;
  showAverage2: boolean;
  showVolumeInLegend: boolean;
  showEventsInLegend: boolean;
  showSentiment1InLegend: boolean;
  showSentiment2InLegend: boolean;
  showScoreInLegend: boolean;
  showScoreEInLegend: boolean;
  showScoreSInLegend: boolean;
  showScoreGInLegend: boolean;
  showPriceInLegend: boolean;

  //additional param for llm chat charts widgets path: ../../../project/llm/chat-charts/chat-charts.component.ts
  customScore: string;
  screenSize$ = this.breakpointService.screenSize$;
  isMobile$: boolean;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public routing: RoutingService,
    private dialog: MatDialog,
    private colorpipe: ColorPipe,
    private colorpipeScore: ColorScorePipe,
    private colorpipeScore2: ColorScore2Pipe,
    private featureFlagsService: FeatureFlagsService,
    private queryApi: QueryApiService,
    public userState: UserStateService,
    public config: ConfigService,
    private breakpointService: BreakpointService,
    private newsChartScoreService: NewsChartScoreService,
    private scoreFocusedEventsService: ScoreFocusedEventsService,
    private newsChartEventsService: NewsChartEventsService,
    private sentimentService: SentimentService,
    private priceDataService: PriceDataService,
    private newsChartDataService: NewsChartDataService,
    private portfolioApi: PortfolioApiService,
  ) {
    this.customScore = this.featureFlagsService.scorelabSettings.defaultScore;

    this.project = this.config.appConfig.routing.project;
    this.setup = this.config.appConfig.setup;

    this.showVolumeInLegend = true;
    this.showEventsInLegend = true;
    this.showSentiment1InLegend = false;
    this.showSentiment2InLegend = false;
    this.showScoreInLegend = true;
    this.showScoreEInLegend = false;
    this.showScoreSInLegend = false;
    this.showScoreGInLegend = false;
    this.showPriceInLegend = false;

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.params = JSON.parse(JSON.stringify(params));
        this.customScore =
          this.featureFlagsService.scorelabSettings.defaultScore;

        this.showAverage = false;
        this.showAverage2 = false;
        this.fromSearchQuery =
          this.routing.isQuery() || this.routing.isSearch();

        this.fromPortfolio = this.routing.isFolio() && !params.portfolioId;
        // `score` in the URL overrides the user's default score (set only by
        // alert links via redirectGuard). The chart simply displays it.
        this.scoreOverride =
          routing.isChart() &&
          (routing.isFolio() || routing.isMarket()) &&
          this.params.score;
        this.scoreOnChart = this.scoreOverride
          ? this.params.score
          : this.customScore;
        this.esgSetup = this.scoreOnChart === 'esg';

        if (this.params.fully) {
          this.fully = { min: 0, max: 1 };
        } else {
          this.fully = { min: null, max: null };
        }
        this.theme = this.routing.theme;
        this.ievents = [];
        this.ioption = {
          color: this.theme === 'dark' ? '255, 255, 255' : '0, 0, 0',
          colorAudit: '94, 107, 120',
          yAxis: {
            score: {
              gridLineWidth: 2,
              crosshair: null,
            },
          },
          isprice: false,
          exporting: false,
        };

        if (!this.instart) {
          this.instart = true;
          this.initZoom();
        } else {
          if (this.iizoom !== this.params.time) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            this.params.time
              ? (this.timeframe = this.params.time)
              : (this.timeframe = '7');
            this.iizoom = this.params.time;
            this.initZoom();
          }
        }
        const refreshParams = [
          'type',
          'id',
          'isin',
          'time',
          'lang',
          'feed',
          'categories',
          'continents',
          'countries',
          'factuality',
          'temporality',
          'ranks',
          'panels',
          'period1',
          'period2',
          'update',
          'theme',
          'fullscreen',
          'fully',
          'score_type',
          'score',
        ];
        refreshParams.push('eventid');
        const redrawParams = [
          'newsday',
          'eventid',
          'tag',
          'newstype',
          'sort',
          'news',
        ];
        if (
          this.routing.reFresh(this.params, this.previousValue, redrawParams)
        ) {
          if (this.options) {
            this.options['chart']['animation'] = false;
            this.options['plotOptions']['series']['animation'] = false;
            this.stockChart = new StockChart(this.options);
          }
        }
        const reflowParams = ['reflow'];
        if (
          this.routing.reFresh(this.params, this.previousValue, reflowParams)
        ) {
          this.reflowChart(this.izoomRef);
          this.reflowChart(this.stockChartRef);
        }
        if (
          this.routing.reFresh(this.params, this.previousValue, refreshParams)
        ) {
          // Cancel the previous refresh's in-flight fetch (e.g. on company switch).
          this.refreshCancel$.next();
          this.loading = true;
          this.nodata = false;
          this.initChart();
          this.initZoom();
          this.reflowChart(this.izoomRef);
          this.reflowChart(this.stockChartRef);
        }
        this.previousValue = this.params;
      });
  }

  ngOnInit() {
    this.breakpointService.screenSize$.pipe(take(1)).subscribe((screen) => {
      if (screen.isMobile) {
        this.isMobile$ = true;
      } else {
        this.isMobile$ = false;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.refreshCancel$.complete();
    this.disconnectChartObservers();
  }

  initZoom() {
    const dateFrom = DateUtils.fromTo(
      this.config.appConfig.setup.startDate,
    ).dateFrom;
    const dateTo = moment().add(1, 'days').format('YYYY-MM-DD');
    this.newsChartDataService
      .fetchVolume(this.params, { izoom: true })
      .pipe(
        catchError(() => {
          return of({
            volume_ts: [
              { volume: 0, date: dateFrom },
              { volume: 0, date: dateTo },
            ],
          });
        }),
      )
      .subscribe(
        (result) => {
          const obj = result['volume_ts'];
          const data = obj.map((daily) => {
            const date = this.geTime(daily.date);
            return [date, daily.volume];
          });

          const navigatorEnabled = true;

          this.options2 = {
            chart: {
              height: 60,
              backgroundColor: 'transparent',
            },
            tooltip: { enabled: false },
            title: { enabled: false },
            exporting: { enabled: false },
            rangeSelector: { enabled: false },
            scrollbar: { enabled: false },
            credits: { enabled: false },
            navigator: {
              top: 12,
              enabled: navigatorEnabled,
              height: 30,
              handles: {
                enabled: true,
                backgroundColor: 'rgba(' + this.ioption.color + ', 0.2)',
                borderColor: 'rgba(' + this.ioption.color + ', 0.2)',
              },
              outlineColor: 'transparent',
              maskFill: 'rgba(' + this.ioption.color + ', 0.1)',
              series: {
                color: 'rgba(' + this.ioption.color + ', 0.2)',
                lineColor: 'transparent',
              },
              xAxis: {
                gridLineColor: 'rgba(' + this.ioption.color + ', 0.2)',
                labels: {
                  style: {
                    color: 'rgba(' + this.ioption.color + ', 0.2)',
                  },
                },
              },
            },
            yAxis: {
              height: 0,
              gridLineWidth: 0,
              labels: {
                enabled: false,
              },
            },
            xAxis: {
              min: this.getRange().min,
              max: this.getRange().max,
              maxRange: this.routing.isDev()
                ? undefined
                : INTERNAL_COCKPIT_SETTINGS.maxTimeframe * 24 * 3600000,
              type: 'datetime',
              ordinal: false,
              lineWidth: 0,
              tickLength: 0,
              labels: {
                enabled: false,
              },
              events: {
                afterSetExtremes: (event) =>
                  this.onAfterSetExtremes(event, true),
              },
            },
            series: [
              {
                type: 'area',
                name: '',
                lineWidth: 0,
                marker: {
                  enabled: false,
                  states: {
                    hover: {
                      enabled: false,
                    },
                  },
                },
                data: data,
                tooltip: {
                  valueDecimals: 2,
                },
              },
            ],
          };
          this.izoom = new StockChart(this.options2);
          this.izoomRef = this.izoom.ref$;
          this.izoomRef.subscribe((res) => {
            let startDate = '';
            let endDate = '';
            let highchartsTextObject;

            const calculatePosition = (
              navLeft,
              navRight,
              textSize,
              boxSize,
              boxPadding,
            ) => {
              const positionLeft = Math.round(
                (navLeft + navRight - textSize) * 0.5,
              );
              const positionRight = Math.round(
                (navLeft + navRight + textSize) * 0.5,
              );
              if (positionLeft < 0) {
                return 0;
              } else if (positionRight > boxSize + boxPadding) {
                return boxSize + boxPadding - textSize;
              } else {
                return positionLeft;
              }
            };
            const calculateDates = (
              dateMin,
              dateMax,
              navMin,
              navMax,
              navSize,
            ) => {
              return {
                start: Math.ceil(
                  dateMin + ((dateMax - dateMin) * navMin) / navSize,
                ),
                end: Math.floor(
                  dateMin + ((dateMax - dateMin) * navMax) / navSize,
                ),
              };
            };
            if (navigatorEnabled) {
              const navContainer = document.getElementsByClassName(
                'highcharts-navigator',
              )[0];
              navContainer.addEventListener(
                'mousemove',
                () => {
                  if (
                    highchartsTextObject &&
                    !(Object.keys(highchartsTextObject).length === 0)
                  ) {
                    highchartsTextObject.destroy();
                  }
                  const dateRange = calculateDates(
                    res.navigator.xAxis.min,
                    res.navigator.xAxis.max,
                    res.navigator.zoomedMin,
                    res.navigator.zoomedMax,
                    res.navigator.size,
                  );
                  startDate = moment(dateRange.start).format('DD.MM.YYYY');
                  endDate = moment(dateRange.end).format('DD.MM.YYYY');
                  highchartsTextObject = res.renderer
                    .text(startDate + ' - ' + endDate, 0, 0, 'useHTML')
                    .attr({ id: 'navTooltip' })
                    .css({ color: 'transparent' })
                    .add();
                  const tooltipContainer =
                    document.getElementById('navTooltip');
                  const tooltipContainerWidth = tooltipContainer.offsetWidth;
                  highchartsTextObject.destroy();
                  const textPositionX = calculatePosition(
                    res.navigator.outline.pathArray[1][1],
                    res.navigator.outline.pathArray[3][1],
                    tooltipContainerWidth,
                    res.navigator.size,
                    res.navigator.left,
                  );
                  const color = 'rgba(' + this.ioption.color + ', 0.4)';
                  const transY = 3.5;
                  highchartsTextObject = res.renderer
                    .text(
                      startDate + ' - ' + endDate,
                      textPositionX,
                      res.navigator.outline.pathArray[1][2] - transY,
                    )
                    .css({ color: color, fontSize: 12 })
                    .add();
                },
                false,
              );
              navContainer.addEventListener(
                'mouseleave',
                () => {
                  if (
                    highchartsTextObject &&
                    !(Object.keys(highchartsTextObject).length === 0)
                  ) {
                    highchartsTextObject.destroy();
                  }
                },
                false,
              );
            }
          });
        },
        () => {
          this.nodata = true;
          this.loading = false;
        },
      );
  }

  initChart() {
    // Charts are about to be rebuilt; drop observers bound to the old instances.
    this.disconnectChartObservers();
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.params.time
      ? (this.timeframe = this.params.time)
      : (this.timeframe = '7');
    const timeframeLength = DateUtils.chartFromTo(this.timeframe).period;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.params.period1
      ? (this.period1 = parseInt(this.params.period1, 10))
      : timeframeLength <= 7
        ? (this.period1 = 1)
        : (this.period1 = 7);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.params.period2
      ? (this.period2 = parseInt(this.params.period2, 10))
      : timeframeLength <= 7
        ? (this.period2 = 7)
        : (this.period2 = 30);

    forkJoin({
      titolo: this.fromSearchQuery
        ? this.sentimentService
            .getSentiment({ ...this.params, getSanctions: true }, false)
            .pipe(
              catchError(() => {
                return of({ entity: {}, sentiment: {} });
              }),
            )
        : this.newsChartScoreService
            .fetchEntitySentiment({
              period: this.params.period,
              newsday: this.params.newsday,
              getSanctions: false,
            })
            .pipe(
              catchError(() => {
                return of({ entity: {}, sentiment: {} });
              }),
            ),
      volume: this.newsChartDataService.fetchVolume(this.params).pipe(
        catchError(() => {
          return of({ volume_ts: [] });
        }),
      ),
      score: this.fromSearchQuery
        ? this.newsChartDataService
            .fetchQuerySentiment(this.params, this.period1)
            .pipe(
              catchError(() => {
                return of({ quotient_ts: [] });
              }),
            )
        : this.newsChartScoreService.fetchSentimentTimeSeries(
            this.period1,
            this.timeframe,
          ),
      // Queries/search only ever chart sentiment, so the ESG setup must not
      // suppress the long sentiment line there — ESG series can't load anyway.
      score2:
        !this.esgSetup || this.fromSearchQuery
          ? this.fromSearchQuery
            ? this.newsChartDataService
                .fetchQuerySentiment(this.params, this.period2)
                .pipe(
                  catchError(() => {
                    return of({ quotient_ts: [] });
                  }),
                )
            : this.newsChartScoreService.fetchSentimentTimeSeries(
                this.period2,
                this.timeframe,
              )
          : of({ quotient_ts: [] }),
      price:
        !this.fromPortfolio && !this.fromSearchQuery
          ? this.priceDataService
              .getYlPrice(this.params.type, this.params.id, this.params)
              .pipe(
                catchError(() => {
                  return of({ prices: [], currency: [] });
                }),
              )
          : of({ prices: [], currency: [] }),
      scores:
        (!(this.scoreOnChart === 'sentiment') &&
          (this.routing.isFolio() ||
            (this.params.type &&
              (this.params.type === 'company' ||
                this.params.type === 'pne' ||
                ['industry', 'supersector', 'sector', 'subsector'].includes(
                  this.params.type,
                ))))) ||
        Object.prototype.hasOwnProperty.call(this.params, 'isin')
          ? this.newsChartScoreService.fetchScoreTimeSeries(
              this.newsChartScoreService.resolveScoreType(this.scoreOnChart),
              this.timeframe,
            )
          : of({ score_ts: [], score_ts_last_score: null }),
      scoreE:
        this.esgSetup &&
        (this.routing.isFolio() ||
          (this.params.type &&
            (this.params.type === 'company' ||
              this.params.type === 'pne' ||
              ['industry', 'supersector', 'sector', 'subsector'].includes(
                this.params.type,
              ))) ||
          this.params.isin)
          ? this.newsChartScoreService.fetchScoreTimeSeries(
              'e_standard',
              this.timeframe,
            )
          : of({ score_ts: [], score_ts_last_score: null }),
      scoreS:
        this.esgSetup &&
        (this.routing.isFolio() ||
          (this.params.type &&
            (this.params.type === 'company' ||
              this.params.type === 'pne' ||
              ['industry', 'supersector', 'sector', 'subsector'].includes(
                this.params.type,
              ))) ||
          this.params.isin)
          ? this.newsChartScoreService.fetchScoreTimeSeries(
              's_standard',
              this.timeframe,
            )
          : of({ score_ts: [], score_ts_last_score: null }),
      scoreG:
        this.esgSetup &&
        (this.routing.isFolio() ||
          (this.params.type &&
            (this.params.type === 'company' ||
              this.params.type === 'pne' ||
              ['industry', 'supersector', 'sector', 'subsector'].includes(
                this.params.type,
              ))) ||
          this.params.isin)
          ? this.newsChartScoreService.fetchScoreTimeSeries(
              'g_standard',
              this.timeframe,
            )
          : of({ score_ts: [], score_ts_last_score: null }),
    })
      .pipe(takeUntil(merge(this.destroy$, this.refreshCancel$)))
      .subscribe(
        (resArgs) => {
          const results = JSON.parse(JSON.stringify(resArgs));
          // Always populate the title from the response — skipping it left
          // `titolo` unset (and getScore() crashing) whenever a non-default
          // score is shown via the URL.
          if (results.titolo) {
            if (
              results.titolo.entity.type === 'portfolio' &&
              this.portfolioApi.activePortfolio
            ) {
              this.titolo = {
                ...results.titolo,
                entity: {
                  ...results.titolo.entity,
                  name: this.portfolioApi.activePortfolio.name || '',
                },
              };
            } else if (this.fromSearchQuery && this.queryApi.query?.name) {
              this.titolo = {
                ...results.titolo,
                entity: {
                  ...results.titolo.entity,
                  name: this.queryApi.query.name,
                },
              };
            } else {
              this.titolo = {
                ...results.titolo,
              };
            }
            if (
              !(this.scoreOnChart === 'sentiment') &&
              (this.routing.isFolio() ||
                (this.params.type &&
                  (this.params.type === 'company' ||
                    this.params.type === 'pne' ||
                    ['industry', 'supersector', 'sector', 'subsector'].includes(
                      this.params.type,
                    ))) ||
                Object.prototype.hasOwnProperty.call(this.params, 'isin'))
            ) {
              if (['bb'].includes(this.scoreOnChart)) {
                const lastBbScore = ScoreUtilsService.getLastScore(
                  results.scores['score_ts'],
                );
                const { trendType, trendValue } =
                  ScoreUtilsService.getBullBearTrend(lastBbScore);
                this.titolo = {
                  ...this.titolo,
                  score: lastBbScore,
                  trend_value: trendValue,
                  trend_type: trendType,
                };
              } else {
                const scoreTs = results.scores['score_ts'] || [];
                const lastScore = ScoreUtilsService.getLastScore(scoreTs);
                const firstScoreEntry = scoreTs.find(
                  (p: { score: number | null }) =>
                    p.score !== null && p.score !== undefined,
                );
                const firstScore = firstScoreEntry?.score ?? null;
                const scoreDelta =
                  lastScore !== null && firstScore !== null
                    ? Number((lastScore - firstScore).toFixed(2))
                    : null;
                this.titolo = {
                  ...this.titolo,
                  score:
                    lastScore !== null ? Number(lastScore.toFixed(1)) : null,
                  score_delta: scoreDelta,
                };
              }
            }
          }
          this.volume_ts = results.volume['volume_ts'];
          this.quotient_ts = results.score['quotient_ts'];
          this.quotient_ts2 = results.score2['quotient_ts'];
          this.score_ts = results.scores['score_ts'];
          this.score_ts_E = results.scoreE['score_ts'];
          this.score_ts_S = results.scoreS['score_ts'];
          this.score_ts_G = results.scoreG['score_ts'];
          this.scoreE_last = results.scoreE['score_ts_last_score']
            ? results.scoreE['score_ts_last_score']['score']
            : null;
          this.scoreS_last = results.scoreS['score_ts_last_score']
            ? results.scoreS['score_ts_last_score']['score']
            : null;
          this.scoreG_last = results.scoreG['score_ts_last_score']
            ? results.scoreG['score_ts_last_score']['score']
            : null;
          this.prices = results.price['prices'];
          this.currency = results.price['currency'];
          // Events are supplementary annotations; don't block the loading
          // spinner on them. Render core score/sentiment/volume now, then
          // fetch events separately and redraw when they arrive.
          this.events = [];
          this.scoreWindowEvents = [];
          this.eventsAnalytics = EMPTY_EVENTS_ANALYTICS();
          // Clear the shared analytics too: event ids are global, so a previous
          // entity's temporality counts would otherwise leak into the mosaic
          // when the new entity's events fetch returns empty.
          this.userState.scoreFocusedEventsAnalytics = null;
          this.renderChart();
          this.loadScoreFocusedEvents();
        },
        () => {
          this.nodata = true;
          this.loading = false;
        },
      );
  }

  /** Rebuild the series from the current data + events and redraw. */
  private renderChart(): void {
    this.disconnectChartObservers();
    this.serie_multi = [];
    if (this.score_ts && this.score_ts.length) {
      this.getScoreArea();
    } else {
      this.getArea();
    }
    this.reflowChart(this.izoomRef);
    this.reflowChart(this.stockChartRef);
  }

  /** Fetch the (slower) score-focused events out of band and redraw with
   *  their annotations once they arrive, so they never gate the spinner. */
  private loadScoreFocusedEvents(): void {
    // Widen to the score's rolling window so the mosaic's drivers all have
    // activity behind them. The mosaic publishes the real `rolling_sum_period`
    // once its fetch lands; until then (and when it isn't visible) the default
    // applies, and any correction is picked up on the next refresh rather than
    // triggering a second request here.
    const windowDays =
      this.scoreFocusedEventsService.scoreWindowDays ??
      DEFAULT_SCORE_WINDOW_DAYS;
    this.newsChartEventsService
      .fetchScoreFocusedEvents(
        this.params,
        this.scoreOverride ? this.params.score : null,
        windowDays,
      )
      .pipe(
        catchError(() =>
          of<NewsChartScoreFocusedEventsResult>({
            events: [],
            eventsAnalytics: EMPTY_EVENTS_ANALYTICS(),
          }),
        ),
        takeUntil(merge(this.destroy$, this.refreshCancel$)),
      )
      .subscribe((bundle) => {
        if (!bundle.events?.length) {
          return;
        }
        // The fetch spans the score's rolling window so the mosaic's sparklines
        // cover every driver, but the chart's x-axis scales to its own series —
        // feeding it the full window would stretch the axis past the selected
        // timeframe. Chart gets the visible slice; the mosaic gets all of it.
        this.scoreWindowEvents = bundle.events;
        this.events = this.clipEventsToTimeframe(bundle.events);
        this.eventsAnalytics = bundle.eventsAnalytics;
        this.renderChart();
      });
  }

  private clipEventsToTimeframe(
    rows: NewsChartEventRow[],
  ): NewsChartEventRow[] {
    const range = DateUtils.fromTo(this.params.time ?? 7);
    return rows.filter(
      (row) => row.date >= range.dateFrom && row.date < range.dateTo,
    );
  }

  iSentiment(value) {
    return (value * 100).toFixed() + '%';
  }
  iColor(value) {
    return 'style="background-color:' + this.colorpipe.transform(value) + '"';
  }

  iSentimentScore(value) {
    return value?.toFixed(2);
  }
  iColorScore(value) {
    return 'style="background-color:' + this.getScoreColor(value);
  }

  // Highcharts' ref$ is a BehaviorSubject — the chart instance lands
  // asynchronously, so subscribing once we get a truthy value avoids the
  // `setTimeout`/race that crashed on undefined.
  private reflowChart(ref: any): void {
    if (!ref) return;
    ref
      .pipe(
        filter((chart: any) => !!chart),
        take(1),
      )
      .subscribe((chart: any) => {
        chart.reflow();
        const container = chart.container?.parentElement;
        if (container && typeof ResizeObserver !== 'undefined') {
          // Guard against a destroyed chart (its container is nulled on destroy)
          // — a stale observer must not call reflow() on it.
          const observer = new ResizeObserver(() => {
            if (chart.container) chart.reflow();
          });
          observer.observe(container);
          this.chartResizeObservers.push(observer);
        }
      });
  }

  private disconnectChartObservers(): void {
    this.chartResizeObservers.forEach((observer) => observer.disconnect());
    this.chartResizeObservers = [];
  }

  private getScoreColor(scoreValue: number): string {
    const scoreType = this.scoreOverride
      ? this.params.score
      : this.params.score_type;
    const fallbackId = this.scoreOverride ? this.scoreOnChart : undefined;
    return getScoreType(
      this.featureFlagsService.scorelabSettings,
      scoreType || fallbackId,
    ) === 'pos'
      ? this.colorpipeScore2.transform(scoreValue)
      : this.colorpipeScore.transform(scoreValue);
  }

  getArea() {
    const data = this.quotient_ts.map((daily) => {
      return [this.geTime(daily.date), daily.quotient];
    });
    const serie_rol = {
      type: 'area',
      name: 'Area',
      lineWidth: 0,
      // threshold: 0,
      color: this.colorpipe.transform(this.titolo.sentiment.sentiment),
      yAxis: 1,
      data: data,
      visible: true,
      showInLegend: false,
      linkedTo: 'average-1',
      tooltip: {
        enabled: false,
      },
      enableMouseTracking: false,
      fillColor: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, this.colorpipe.transform(this.titolo.sentiment.sentiment)],
          [1, 'rgba(0, 0, 0, 0)'],
        ],
      },
    };
    this.serie_multi.push(serie_rol);
    this.getVolume();
  }

  getScoreArea() {
    const data_score = this.score_ts.map((daily) => {
      if (['bb'].includes(this.scoreOnChart)) {
        return [
          this.geTime(moment(daily.date).format('YYYY-MM-DD')),
          daily.score !== null ? Number(daily.score.toFixed(2)) : null,
        ];
      } else {
        return [
          this.geTime(moment(daily.date).format('YYYY-MM-DD')),
          daily.score !== null ? Number(daily.score.toFixed(2)) : null,
        ];
      }
    });
    let color = 'transparent';
    const lastScore = ScoreUtilsService.getLastScore(this.score_ts);
    const scoreValue = this.scoreOverride ? lastScore : this.titolo.score;
    color = this.getScoreColor(scoreValue);
    if (['bb'].includes(this.scoreOnChart)) {
      color =
        this.theme === 'dark'
          ? 'rgba(255, 255, 255, 0.5)'
          : 'rgba(0, 0, 0, 0.5)';
    }
    const serie_rol = {
      type: 'area',
      name: 'ScoreArea',
      lineWidth: 0,
      // threshold: 0,
      color: color,
      yAxis: 2,
      data: data_score,
      visible: true,
      showInLegend: false,
      linkedTo: 'score',
      tooltip: {
        enabled: false,
      },
      enableMouseTracking: false,
      fillColor: {
        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
        stops: [
          [0, color],
          [1, 'rgba(0, 0, 0, 0)'],
        ],
      },
    };
    this.serie_multi.push(serie_rol);
    this.getVolume();
  }

  getVolume() {
    const data = this.volume_ts.map((daily) => {
      return [this.geTime(daily.date), daily.volume];
    });
    const serie_vol = {
      type: 'column',
      name: 'Volume',
      color: 'rgba(' + this.ioption.colorAudit + ', 1.0)',
      borderWidth: 0,
      yAxis: 0,
      data: data,
      showInLegend: true,
      visible: !this.params.eventid && this.showVolumeInLegend,
      tooltip: {
        pointFormat:
          '<tr><td style="color: {series.color}">{series.name}: </td><td style="text-align:right"><b>{point.y}</b></td></tr>',
      },
      events: {
        click: (event) => {
          let newsday = null;
          let time = this.params.time;
          if (event.point.dataGroup) {
            if (event.point.dataGroup.length === 7) {
              const week = moment(this.getRange().min).add(
                event.point.dataGroup.start,
                'days',
              );
              time =
                week.format('YYYY-MM-DD') +
                '--' +
                week.add(7, 'days').format('YYYY-MM-DD');
            }
            if (event.point.dataGroup.length === 1) {
              newsday = moment(event.point.x).format('YYYY-MM-DD');
            }
          } else {
            newsday = moment(event.point.x).format('YYYY-MM-DD');
          }
          let path = [];
          if (this.isMobile$) {
            path = ['/news/newsfeed'];
          }
          this.router.navigate(path, {
            queryParams: {
              newsday: newsday,
              news: null,
              tag: null,
              time: time,
            },
            queryParamsHandling: 'merge',
            replaceUrl: false,
          });
        },
        legendItemClick: (event) => {
          this.showVolumeInLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_vol);
    this.getEvent();
  }

  getEvent() {
    if (this.events.length > 0) {
      const name = 'Events';
      let data = [];
      if (this.params.eventype === 'sub_event') {
        const dataevent = this.events.filter(
          (d) => d.sub_event.id === this.params.eventid,
        );
        data = _.map(
          _.toPairs(
            _.mapValues(
              _.groupBy(dataevent, (d) => d.date),
              (vs) => _.sumBy(vs, (v) => v.count),
            ),
          ),
          (x) => ({ date: x[0], count: x[1] }),
        );
      } else {
        data = _.map(
          _.toPairs(
            _.mapValues(
              _.groupBy(this.events, (d) => d.date),
              (vs) => _.sumBy(vs, (v) => v.count),
            ),
          ),
          (x) => ({ date: x[0], count: x[1] }),
        );
      }
      const serie_event = {
        type: 'column',
        name: name,

        color: 'rgba(0, 139, 139, 1.0)',
        borderWidth: 0,
        yAxis: 0,
        data: data.map((item) => [this.geTime(item.date), item.count]),
        showInLegend: true,
        visible: this.showEventsInLegend,
        tooltip: {
          pointFormat:
            '<tr><td style="color: {series.color}">{series.name}: </td><td style="text-align:right"><b>{point.y}</b></td></tr>',
        },
        events: {
          click: (event) => {
            let newsday = null;
            let time = this.params.time;
            if (event.point.dataGroup) {
              if (event.point.dataGroup.length === 7) {
                const week = moment(this.getRange().min).add(
                  event.point.dataGroup.start,
                  'days',
                );
                time =
                  week.format('YYYY-MM-DD') +
                  '--' +
                  week.add(7, 'days').format('YYYY-MM-DD');
              }
              if (event.point.dataGroup.length === 1) {
                newsday = moment(event.point.x).format('YYYY-MM-DD');
              }
            } else {
              newsday = moment(event.point.x).format('YYYY-MM-DD');
            }
            let path = [];
            if (this.isMobile$) {
              path = ['/news/newsfeed'];
            }
            this.router.navigate(path, {
              queryParams: {
                newsday: newsday,
                news: null,
                tag: null,
                time: time,
              },
              queryParamsHandling: 'merge',
              replaceUrl: false,
            });
          },
          legendItemClick: (event) => {
            this.showEventsInLegend = !event.target.visible;
          },
        },
      };
      this.scoreFocusedEventsService.setEvents(this.scoreWindowEvents);
      // Legacy widget contract: `fact1..fact4` / `temp1..temp4` keys, each
      // a `{ [sub_event.id]: count }` map.
      const reduceByEventId = (
        rows: { sub_event: { id: string }; count: number }[],
      ) =>
        _.mapValues(
          _.groupBy(rows, (e) => e.sub_event.id),
          (vs) => _.sumBy(vs, (v) => v.count),
        );
      const fact = this.eventsAnalytics.byFactuality;
      const temp = this.eventsAnalytics.byTemporality;
      this.userState.scoreFocusedEventsAnalytics = {
        fact1: reduceByEventId(fact.fact),
        fact2: reduceByEventId(fact.probable),
        fact3: reduceByEventId(fact.possible),
        fact4: reduceByEventId(fact.na),
        temp1: reduceByEventId(temp.past),
        temp2: reduceByEventId(temp.present),
        temp3: reduceByEventId(temp.future),
        temp4: reduceByEventId(temp.na),
      };
      this.serie_multi.push(serie_event);
    }
    this.getScore();
  }

  getScore() {
    const data = this.quotient_ts.map((daily) => {
      return [this.geTime(daily.date), daily.quotient];
    });
    const serie_rol = {
      id: 'average-1',
      type: 'line',
      name: this.period1 + (this.period1 > 1 ? ' days' : ' day') + ' Sentiment',
      lineWidth: !(this.score_ts && this.score_ts.length) ? 4 : 3,
      color: this.colorpipe.transform(this.titolo.sentiment.sentiment),
      yAxis: 1,
      data: data,
      visible:
        !(this.score_ts && this.score_ts.length) || this.showSentiment1InLegend,
      showInLegend: true,
      tooltip: {
        valueDecimals: 2,
        pointFormatter: function () {
          const percent = this.y * 100;
          const string =
            '<tr><td style="color:' +
            this.series.color +
            '">' +
            this.series.name +
            ' : </td>' +
            '<td style="text-align:right"><b>' +
            percent.toFixed(0) +
            '%</b></td></tr>';
          return string;
        },
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showSentiment1InLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_rol);
    this.getScore2();
  }

  getScore2() {
    const data = this.quotient_ts2.map((daily) => {
      return [this.geTime(daily.date), daily.quotient];
    });
    const serie_rol = {
      type: 'line',
      name: this.period2 + (this.period2 > 1 ? ' days' : ' day') + ' Sentiment',
      lineWidth: 3,
      dashStyle: 'ShortDot',
      color: 'rgba(163, 81, 254, 0.6)',
      yAxis: 1,
      data: data,
      visible:
        !(this.score_ts && this.score_ts.length) || this.showSentiment2InLegend,
      showInLegend: !this.esgSetup || this.fromSearchQuery,
      tooltip: {
        valueDecimals: 2,
        pointFormatter: function () {
          const percent = this.y * 100;
          const string =
            '<tr><td style="color:' +
            this.series.color +
            '">' +
            this.series.name +
            ' : </td>' +
            '<td style="text-align:right"><b>' +
            percent.toFixed(0) +
            '%</b></td></tr>';
          return string;
        },
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showSentiment2InLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_rol);
    if (this.score_ts && this.score_ts.length) {
      this.getScores();
    } else {
      this.getPrice();
    }
  }

  getScores() {
    const data_score = this.score_ts.map((daily) => {
      if (['bb'].includes(this.scoreOnChart)) {
        return [
          this.geTime(moment(daily.date).format('YYYY-MM-DD')),
          daily.score !== null ? Number(daily.score.toFixed(2)) : null,
        ];
      } else {
        return [
          this.geTime(moment(daily.date).format('YYYY-MM-DD')),
          daily.score !== null ? Number(daily.score.toFixed(2)) : null,
        ];
      }
    });

    let color = 'transparent';
    const lastScore = ScoreUtilsService.getLastScore(this.score_ts);
    const scoreValue = this.scoreOverride ? lastScore : this.titolo.score;
    color = this.getScoreColor(scoreValue);
    if (['bb'].includes(this.scoreOnChart)) {
      color =
        this.theme === 'dark'
          ? 'rgba(255, 255, 255, 0.5)'
          : 'rgba(0, 0, 0, 0.5)';
    }

    if (this.scoreOverride) {
      data_score[data_score.length - 1] = {
        x: data_score[data_score.length - 1][0],
        y: data_score[data_score.length - 1][1],
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 4,
        },
        dataLabels: {
          enabled: true,
          style: {
            color: color,
            textOutline: this.theme === 'dark' ? '#434343' : '#e4e4e4',
          },
        },
      };
    }

    const serie_score = {
      id: 'score',
      type: 'line',
      name:
        getScoresInfo(
          this.featureFlagsService.scorelabSettings,
          this.scoreOnChart,
        )['short'] + ' Score',
      lineWidth: 4,
      color: color,
      yAxis: 2,
      data: data_score,
      visible: this.showScoreInLegend,
      showInLegend: true,
      tooltip: {
        pointFormat:
          '<tr><td style="color:{series.color}">{series.name}: </td>' +
          '<td style="text-align:right"><b>{point.y}' +
          (['bb'].includes(this.scoreOnChart) ? '' : '') +
          '</b></td></tr>',
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showScoreInLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_score);
    if (this.esgSetup) {
      if (this.score_ts_E && this.score_ts_E.length) {
        this.getScoreE();
      } else {
        this.getScoreS();
      }
    } else {
      this.getPrice();
    }
  }

  getScoreE() {
    const data_score = this.score_ts_E.map((daily) => {
      return [
        this.geTime(moment(daily.date).format('YYYY-MM-DD')),
        daily.score !== null ? Number(daily.score.toFixed(2)) : null,
      ];
    });
    const color = this.colorpipeScore2.transform(this.scoreE_last);
    const serie_score = {
      id: 'scoreE',
      type: 'line',
      name: 'E Score',
      lineWidth: 2,
      dashStyle: 'ShortDash',
      color: color,
      yAxis: 2,
      data: data_score,
      visible: this.showScoreEInLegend,
      showInLegend: true,
      tooltip: {
        pointFormat:
          '<tr><td style="color:{series.color}">{series.name}: </td>' +
          '<td style="text-align:right"><b>{point.y}</b></td></tr>',
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showScoreEInLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_score);
    if (this.score_ts_S && this.score_ts_S.length) {
      this.getScoreS();
    } else {
      this.getScoreG();
    }
  }

  getScoreS() {
    const data_score = this.score_ts_S.map((daily) => {
      return [
        this.geTime(moment(daily.date).format('YYYY-MM-DD')),
        daily.score !== null ? Number(daily.score.toFixed(2)) : null,
      ];
    });
    const color = this.colorpipeScore2.transform(this.scoreS_last);
    const serie_score = {
      id: 'scoreS',
      type: 'line',
      name: 'S Score',
      lineWidth: 2,
      dashStyle: 'ShortDashDot',
      color: color,
      yAxis: 2,
      data: data_score,
      visible: this.showScoreSInLegend,
      showInLegend: true,
      tooltip: {
        pointFormat:
          '<tr><td style="color:{series.color}">{series.name}: </td>' +
          '<td style="text-align:right"><b>{point.y}</b></td></tr>',
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showScoreSInLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_score);
    if (this.score_ts_G && this.score_ts_G.length) {
      this.getScoreG();
    } else {
      this.getPrice();
    }
  }

  getScoreG() {
    const data_score = this.score_ts_G.map((daily) => {
      return [
        this.geTime(moment(daily.date).format('YYYY-MM-DD')),
        daily.score !== null ? Number(daily.score.toFixed(2)) : null,
      ];
    });
    const color = this.colorpipeScore2.transform(this.scoreG_last);
    const serie_score = {
      id: 'scoreG',
      type: 'line',
      name: 'G Score',
      lineWidth: 2,
      dashStyle: 'ShortDot',
      color: color,
      yAxis: 2,
      data: data_score,
      visible: this.showScoreGInLegend,
      showInLegend: true,
      tooltip: {
        pointFormat:
          '<tr><td style="color:{series.color}">{series.name}: </td>' +
          '<td style="text-align:right"><b>{point.y}</b></td></tr>',
      },
      marker: {
        symbol: 'circle',
      },
      events: {
        legendItemClick: (event) => {
          this.showScoreGInLegend = !event.target.visible;
        },
      },
    };
    this.serie_multi.push(serie_score);
    this.getPrice();
  }

  getPrice() {
    if (this.prices && this.prices.length) {
      const data_price = this.prices.map((daily) => {
        return [
          this.geTime(moment(daily.date).format('YYYY-MM-DD')),
          daily.price,
        ];
      });
      this.ioption.isprice = true;
      const serie_price = {
        type: 'line',
        name: 'Price ' + this.currency,
        lineWidth: 2,
        color: 'rgba(' + this.ioption.color + ', 0.3)',
        yAxis: 3,
        data: data_price,
        visible:
          !(this.score_ts && this.score_ts.length) || this.showPriceInLegend,
        showInLegend: true,
        tooltip: {
          pointFormat:
            '<tr><td style="color:{series.color}">{series.name}: </td>' +
            '<td style="text-align:right"><b>{point.y}</b></td></tr>',
        },
        marker: {
          symbol: 'circle',
        },
        events: {
          legendItemClick: (event) => {
            this.showPriceInLegend = !event.target.visible;
          },
        },
      };
      this.serie_multi.push(serie_price);
      this.getOption();
    } else {
      this.getOption();
    }
  }

  getOption() {
    const thatScore = this.scoreOnChart;
    const marginBottom = 25;
    this.options = {
      title: { enabled: false },
      chart: {
        marginTop: null,
        marginBottom: marginBottom,
        backgroundColor: 'transparent',
        zoomType: 'x',
        alignTicks: false,
        events: {
          load: function () {},
          render: function () {
            if (this.resetZoomButton) {
              this.resetZoomButton.hide();
            }
            // this.resetZoomButton.destroy();
          },
        },
      },
      scrollbar: { enabled: false },
      credits: { enabled: false },
      exporting: {
        enabled: false,
      },
      legend: {
        enabled: this.isMobile$ ? false : true,
        // layout: 'vertical',
        // floating: true,
        // backgroundColor: 'rgba(0, 0, 0, 0.5)',
        verticalAlign: 'top',
        align: 'left',
        y: 0,
        // symbolWidth: 33,
        itemStyle: {
          color: 'rgba(' + this.ioption.color + ', 0.4)',
        },
        itemHoverStyle: {
          color: 'rgba(' + this.ioption.color + ', 0.6)',
        },
        itemHiddenStyle: {
          color: 'rgba(' + this.ioption.color + ', 0.1)',
        },
      },
      tooltip: {
        shared: true,
        split: false,
        followPointer: true,
        followTouchMove: true,
        backgroundColor: 'rgba(' + this.ioption.color + ', 0.1)',
        borderColor: 'transparent',
        shadow: false,
        style: {
          color: 'white',
          fontSize: 14,
        },
        useHTML: true,
        headerFormat: '<small>{point.key}</small><table>',

        footerFormat: '</table>',
      },
      rangeSelector: { enabled: false },
      navigator: {
        enabled: false,
        height: 20,
        adaptToUpdatedData: false,
        baseSeries: 1,
        handles: {
          backgroundColor: 'rgba(' + this.ioption.color + ', 0.2)',
          borderColor: 'rgba(' + this.ioption.color + ', 0.2)',
        },
        outlineColor: 'transparent',
        maskFill: 'rgba(' + this.ioption.color + ', 0.1)',
        series: {
          color: 'rgba(' + this.ioption.color + ', 0.2)',
          lineColor: 'transparent',
        },
        xAxis: {
          gridLineColor: 'rgba(' + this.ioption.color + ', 0.2)',
          labels: {
            style: {
              color: 'rgba(' + this.ioption.color + ', 0.2)',
            },
          },
        },
      },
      xAxis: {
        type: 'datetime',
        ordinal: false,
        labels: {
          style: {
            color: 'rgba(' + this.ioption.color + ', 0.4)',
          },
          rotation: 0,
        },
        lineColor: 'rgba(' + this.ioption.color + ', 0.2)',
        tickColor: 'rgba(' + this.ioption.color + ', 0.2)',
        crosshair: {
          enabled: false,
          snap: false,
          width: 1,
          color: 'rgba(' + this.ioption.color + ', 0.2)',
        },
        gridLineColor: 'rgba(' + this.ioption.color + ', 0.05)',
        gridLineWidth: 0,
        events: {
          afterSetExtremes: (event) => this.onAfterSetExtremes(event, false),
        },
      },
      yAxis: [
        {
          title: { text: 'Volume', enabled: false },
          endOnTick: true,
          opposite: false,
          allowDecimals: false,
          labels: {
            y: 3,
            style: { color: 'rgba(' + this.ioption.color + ', 0.3)' },
            enabled: true,
          },
          gridLineColor: 'transparent',
          lineColor: 'rgba(' + this.ioption.color + ', 0.05)',
          lineWidth: 2,
        },
        {
          title: {
            text:
              getScoresInfo(
                this.featureFlagsService.scorelabSettings,
                this.scoreOnChart,
              )['short'] + ' Score',
            enabled: false,
          },
          max: this.fully.max,
          min: this.fully.min,
          // startOnTick: true,
          // endOnTick: true,
          labels: {
            // y: 3,
            align: 'left',
            style: {
              color: 'rgba(' + this.ioption.color + ', 0.5)',
              fontWeight: 'normal',
            },
            enabled: !(this.score_ts && this.score_ts.length),
            formatter: function () {
              return Math.round(this.value * 100) + '%';
            },
          },
          gridLineColor: !(this.score_ts && this.score_ts.length)
            ? 'rgba(' + this.ioption.color + ', 0.05)'
            : 'transparent',
          gridLineWidth: this.ioption.yAxis.score.gridLineWidth,
          lineColor: !(this.score_ts && this.score_ts.length)
            ? 'rgba(' + this.ioption.color + ', 0.05)'
            : 'transparent',
          lineWidth: 2,
        },
        {
          title: {
            text:
              getScoresInfo(
                this.featureFlagsService.scorelabSettings,
                this.scoreOnChart,
              )['short'] + ' Score',
            enabled: false,
          },
          opposite: true,
          max: null,
          min: null,
          labels: {
            // y: 3,
            align: 'left',
            style: {
              color: 'rgba(' + this.ioption.color + ', 0.5)',
              fontWeight: 'normal',
            },
            // enabled: this.ioption.isprice,
            enabled: this.score_ts && this.score_ts.length,
            formatter: function () {
              if (['bb'].includes(thatScore)) {
                return this.value;
              } else {
                return this.value;
              }
            },
          },
          gridLineColor:
            this.score_ts && this.score_ts.length
              ? 'rgba(' + this.ioption.color + ', 0.05)'
              : 'transparent',
          gridLineWidth: this.ioption.yAxis.score.gridLineWidth,
          lineColor:
            this.score_ts && this.score_ts.length
              ? 'rgba(' + this.ioption.color + ', 0.05)'
              : 'transparent',
          lineWidth: 2,
        },
        {
          title: { text: 'Price', enabled: false },
          opposite: false,
          labels: {
            y: 3,
            style: { color: 'rgba(' + this.ioption.color + ', .4)' },
            // enabled: this.ioption.isprice,
            enabled: false,
          },
          gridLineColor: 'transparent',
        },
      ],
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1,
            },
          },
          maxPointWidth: 20,
          // dataGrouping: {
          //   // forced: false,
          //   units: [
          //     ['day', [3]]
          //   ]
          // },
          marker: {
            enabled: DateUtils.chartFromTo(this.timeframe).period < 31,
          },
          cursor: 'pointer',
          connectNulls: true,
          // clip: true
          // crisp: false
        },
        column: {
          grouping: true,
          states: {
            hover: {
              color: 'rgba(' + this.ioption.color + ', 0.4)',
            },
          },
        },
      },
      annotations: [
        {
          labels: this.ievents,
        },
      ],
      series: this.serie_multi,
    };
    this.stockChart = new StockChart(this.options);
    this.stockChartRef = this.stockChart.ref$;

    this.loading = false;
  }

  getStops(data) {
    const data1 = data
      .filter(
        (risp) =>
          risp[1] != null &&
          new Date(risp[0]).getTime() > this.getRange().min &&
          new Date(risp[0]).getTime() < this.getRange().max,
      )
      .sort((a, b) => a - b)
      .map((risp) => risp[1]);
    // eslint-disable-next-line prefer-spread
    const value_min = Math.min.apply(Math, data1);
    // eslint-disable-next-line prefer-spread
    const value_max = Math.max.apply(Math, data1);
    const value_mid = (value_min + value_max) / 2;
    const colorScale = d3
      .scaleLinear<string>()
      .domain([0, 0.5, 1])
      .range(['#dd001a', '#f6d500', '#3dac00']);
    return [
      [0, colorScale(value_max.toFixed(2)).toString()],
      [0.5, colorScale(Number(value_mid.toFixed(2))).toString()],
      [1, colorScale(value_min.toFixed(2)).toString()],
    ];
  }

  getRange() {
    const fromto = DateUtils.chartFromTo(this.timeframe);
    const range = {
      min: moment.utc(fromto.dateFrom).valueOf(),
      max: moment.utc(fromto.dateTo).valueOf(),
    };
    return range;
  }

  getAllDaysFormatted() {
    const fromto = DateUtils.chartFromTo(this.timeframe);
    const range = {
      min: moment.utc(fromto.dateFrom),
      max: moment.utc(fromto.dateTo),
    };
    const howManyDays = range.max.diff(range.min, 'days');
    const allDays = [];
    for (let i = 0; i <= howManyDays; i++) {
      allDays.push(
        moment(range.min).add(i, 'days').format('YYYY-MM-DD').valueOf(),
      );
    }
    return allDays;
  }

  inChart() {
    if (this.routing.isPath('iframe')) {
      const bool = this.params.chartvol === 'false';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { chartvol: bool },
        queryParamsHandling: 'merge',
      });
    }
  }

  goInfo() {
    this.dialog.open(ChartLegendComponent, { data: {} });
  }

  getAverage() {
    if (this.showAverage2) {
      this.showAverage2 = false;
    }
    this.showAverage = !this.showAverage;
  }

  getAverage2() {
    if (this.showAverage) {
      this.showAverage = false;
    }
    this.showAverage2 = !this.showAverage2;
  }

  geTime(value) {
    return moment.utc(value).valueOf();
  }

  onAfterSetExtremes(event, izoom) {
    if (event.trigger === 'zoom' || event.trigger === 'navigator') {
      const time =
        moment(event.min).format('YYYY-MM-DD') +
        '--' +
        moment(event.max).format('YYYY-MM-DD');
      if (izoom) {
        this.iizoom = time;
      }
      this.router.navigate([], {
        queryParams: {
          time: time,
          newsday: null,
        },
        queryParamsHandling: 'merge',
      });
    }
  }

  imgChart(format) {
    if (format === 'jpg') {
      domtoimage
        .toJpeg(document.getElementById('chartcanvas'), { quality: 1 })
        .then(function (dataUrl) {
          const link = document.createElement('a');
          link.download =
            Math.random().toString().replace('0.', '') + '.' + format;
          link.href = dataUrl;
          link.click();
        });
    }
    if (format === 'png') {
      domtoimage
        .toPng(document.getElementById('chartcanvas'), { quality: 1 })
        .then(function (dataUrl) {
          const link = document.createElement('a');
          link.download =
            Math.random().toString().replace('0.', '') + '.' + format;
          link.href = dataUrl;
          link.click();
        });
    }
    if (format === 'svg') {
      domtoimage
        .toSvg(document.getElementById('chartcanvas'), { quality: 1 })
        .then(function (dataUrl) {
          const link = document.createElement('a');
          link.download =
            Math.random().toString().replace('0.', '') + '.' + format;
          link.href = dataUrl;
          link.click();
        });
    }
  }

  exportChartData(format, what) {
    const doubleArrayData = [[]];
    doubleArrayData[0].push('Date');
    let itemName = '';
    if (this.routing.isQuery()) {
      itemName = this.queryApi.query.name + ' - ';
    } else {
      itemName = this.titolo.entity.name + ' - ';
    }
    what.forEach((type) => {
      if (type === 'volume') {
        doubleArrayData[0].push(itemName + 'Volume');
      } else if (type === 'sentiment') {
        doubleArrayData[0].push(itemName + 'Sentiment');
      } else if (type === 'score') {
        const scoreName =
          getScoreNameInfo(this.featureFlagsService.scorelabSettings).short +
          ' Score';
        if (this.esgSetup) {
          doubleArrayData[0].push(itemName + '' + scoreName);
          doubleArrayData[0].push(itemName + 'E Score');
          doubleArrayData[0].push(itemName + 'S Score');
          doubleArrayData[0].push(itemName + 'G Score');
        } else {
          doubleArrayData[0].push(itemName + '' + scoreName);
        }
      } else if (type === 'price') {
        doubleArrayData[0].push(itemName + 'Price');
      }
    });
    const datesColumn = this.getAllDaysFormatted();
    datesColumn.forEach((date, index) => {
      doubleArrayData.push([date]);
      what.forEach((type) => {
        if (type === 'volume') {
          const rowElement = this.volume_ts.filter((item) => {
            return (
              moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
            );
          });
          if (rowElement.length > 0) {
            doubleArrayData[index + 1].push(rowElement[0].volume);
          } else {
            doubleArrayData[index + 1].push('');
          }
        } else if (type === 'sentiment') {
          const rowElement = this.quotient_ts.filter((item) => {
            return (
              moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
            );
          });
          if (rowElement.length > 0) {
            doubleArrayData[index + 1].push(rowElement[0].quotient);
          } else {
            doubleArrayData[index + 1].push('');
          }
        } else if (type === 'score') {
          if (this.esgSetup) {
            const rowElement = this.score_ts.filter((item) => {
              return (
                moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
              );
            });
            if (rowElement.length > 0) {
              doubleArrayData[index + 1].push(rowElement[0].score);
            } else {
              doubleArrayData[index + 1].push('');
            }
            const rowElementE = this.score_ts_E.filter((item) => {
              return (
                moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
              );
            });
            if (rowElementE.length > 0) {
              doubleArrayData[index + 1].push(rowElementE[0].score);
            } else {
              doubleArrayData[index + 1].push('');
            }
            const rowElementS = this.score_ts_S.filter((item) => {
              return (
                moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
              );
            });
            if (rowElementS.length > 0) {
              doubleArrayData[index + 1].push(rowElementS[0].score);
            } else {
              doubleArrayData[index + 1].push('');
            }
            const rowElementG = this.score_ts_G.filter((item) => {
              return (
                moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
              );
            });
            if (rowElementG.length > 0) {
              doubleArrayData[index + 1].push(rowElementG[0].score);
            } else {
              doubleArrayData[index + 1].push('');
            }
          } else {
            const rowElement = this.score_ts.filter((item) => {
              return (
                moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
              );
            });
            if (rowElement.length > 0) {
              doubleArrayData[index + 1].push(rowElement[0].score);
            } else {
              doubleArrayData[index + 1].push('');
            }
          }
        } else if (type === 'price') {
          const rowElement = this.prices.filter((item) => {
            return (
              moment.utc(item.date).format('YYYY-MM-DD').valueOf() === date
            );
          });
          if (rowElement.length > 0) {
            doubleArrayData[index + 1].push(rowElement[0].price);
          } else {
            doubleArrayData[index + 1].push('');
          }
        }
      });
    });

    const date = new Date();
    const displayDate =
      date.getFullYear() +
      '-' +
      date.getMonth() +
      '-' +
      date.getDate() +
      '_' +
      date.getHours() +
      '-' +
      date.getMinutes() +
      '-' +
      date.getSeconds();
    let itemFileName = '';
    if (this.titolo && this.titolo.entity && this.titolo.entity.type) {
      itemFileName = this.titolo.entity.type;
    }
    const fileName =
      '' + itemFileName + '_' + what.join('_') + '_' + displayDate;
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(doubleArrayData);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    /* save to file */
    if (format === 'xlsx') {
      XLSX.writeFile(wb, fileName + '.xlsx');
    } else if (format === 'csv') {
      XLSX.writeFile(wb, fileName + '.csv');
    }
  }

  inAverage() {
    if (this.period1 > 200) {
      this.period1 = 200;
    }
    if (this.period1 < 1) {
      this.period1 = 1;
    }
    this.router.navigate([], {
      queryParams: {
        period1: this.period1,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  inAverage2() {
    if (this.period2 > 200) {
      this.period2 = 200;
    }
    if (this.period2 < 1) {
      this.period2 = 1;
    }
    this.router.navigate([], {
      queryParams: {
        period2: this.period2,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  goFully() {
    let fully = true;
    if (this.params.fully) {
      fully = null;
    }
    this.router.navigate([], {
      queryParams: {
        fully: fully,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  takeScreenshot() {
    setTimeout(() => {
      const today = moment().format('YYYY-MM-DD');
      this.h2c(document.body).then(function (canvas) {
        canvas.toBlob(function (blob) {
          FileSaver.saveAs(blob, `YukkaLab_${today}.png`);
        });
      });
    }, 500);
  }
}
